// import React, { useState, useEffect } from "react";
// import { format } from "date-fns";

// const BookingHistoryTable = ({ data,onSelectParcel, selectedParcel }) => {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;

//   // Format date from API response
//   const formatDate = (dateString) => {
//     try {
//       return format(new Date(dateString), "dd/MM/yyyy");
//     } catch {
//       return "N/A";
//     }
//   };

//   // Filter data based on search term
//   const filteredData = data?.filter((item) => {
//     if (!searchTerm) return true;
//     return Object.values(item).some(
//       (value) =>
//         value &&
//         value.toString().toLowerCase().includes(searchTerm.toLowerCase())
//     );
//   }) || [];

//   // Pagination logic
//   const totalPages = Math.ceil(filteredData.length / itemsPerPage);
//   const paginatedData = filteredData.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//   // Handle page change
//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };
// const handleRowClick = (item) => {
//   if (onSelectParcel) {
//     onSelectParcel(selectedParcel === item.parcelNo ? null : item);
//   }
// };

//   return (
//     <div className="bg-white rounded-lg shadow-md p-4">
//       {/* Search Input */}
//       <div className="mb-4">
//         <input
//           type="text"
//           placeholder="Search bookings..."
//           className="w-full p-2 border border-gray-300 rounded-md"
//           value={searchTerm}
//           onChange={(e) => {
//             setSearchTerm(e.target.value);
//             setCurrentPage(1); // Reset to first page on new search
//           }}
//         />
//       </div>

//       {/* Table */}
//       <div className="overflow-x-auto">
//         <table className="min-w-full divide-y divide-gray-200">
//           <thead className="bg-gray-50">
//             <tr>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Parcel No
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Date
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Sender
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Receiver
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Route
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Cargo Type
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Total Amount
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Payment Status
//               </th>
//             </tr>
//           </thead>
//           <tbody className="bg-white divide-y divide-gray-200">
//             {paginatedData.length > 0 ? (
//               paginatedData.map((item, index) => (
                
//                 <tr 
//                     key={index} 
//                     onClick={() => handleRowClick(item)}
//                     className={`
//                       ${index % 2 === 0 ? "bg-white" : "bg-gray-50"}
//                       ${selectedParcel === item.parcelNo ? "ring-2 ring-orange-500" : ""}
//                       cursor-pointer hover:bg-gray-100 transition-colors
//                     `}
//                   >
//                   <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
//                     {item.parcelNo || "N/A"}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     {formatDate(item.parcelCreationDate)}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     <div className="flex flex-col">
//                       <span className="font-medium">{item.senderName || "N/A"}</span>
//                       <span className="text-gray-400 text-xs">{item.senderEmail || ""}</span>
//                     </div>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     <div className="flex flex-col">
//                       <span className="font-medium">{item.receiverName || "N/A"}</span>
//                       <span className="text-gray-400 text-xs">{item.receiverEmail || ""}</span>
//                     </div>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     {item.routeName || "N/A"}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     {item.cargoTypeName || "N/A"}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     {item.symbol || ""} {item.subTotal || "0"}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap">
//                     <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
//                       ${item.statusName === "Pending" ? "bg-yellow-100 text-yellow-800" : 
//                         item.statusName === "Shipped" ? "bg-blue-100 text-blue-800" : 
//                         "bg-green-100 text-green-800"}`}>
//                       {item.statusName || "N/A"}
//                     </span>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="8" className="px-6 py-4 text-center text-sm text-gray-500">
//                   No booking history found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       {totalPages > 1 && (
//         <div className="flex justify-between items-center mt-4">
//           <button
//             onClick={() => handlePageChange(Math.max(1, currentPage - 1))}
//             disabled={currentPage === 1}
//             className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50"
//           >
//             Previous
//           </button>
//           <div className="flex space-x-2">
//             {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
//               <button
//                 key={page}
//                 onClick={() => handlePageChange(page)}
//                 className={`px-4 py-2 border rounded-md text-sm font-medium 
//                   ${currentPage === page 
//                     ? "bg-orange-500 text-white border-orange-500" 
//                     : "border-gray-300 text-gray-700 bg-white hover:bg-gray-50"}`}
//               >
//                 {page}
//               </button>
//             ))}
//           </div>
//           <button
//             onClick={() => handlePageChange(Math.min(totalPages, currentPage + 1))}
//             disabled={currentPage === totalPages}
//             className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50"
//           >
//             Next
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default BookingHistoryTable;



// import React, { useState, useEffect } from "react";
// import { format } from "date-fns";
// import { FiFileText } from "react-icons/fi";
// import axios from "axios";

// const BookingHistoryTable = ({ data, onSelectParcel, selectedParcel }) => {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [showReportModal, setShowReportModal] = useState(false);
//   const [reportData, setReportData] = useState(null);
//   const [loadingReport, setLoadingReport] = useState(false);
//   const [currentParcelNo, setCurrentParcelNo] = useState(null);
  
//   const itemsPerPage = 10;
//   const backendUrl = process.env.REACT_APP_API_URL;

//   console.log(data)
//   // Format date from API response
//   const formatDate = (dateString) => {
//     try {
//       return format(new Date(dateString), "dd/MM/yyyy");
//     } catch {
//       return "N/A";
//     }
//   };

//   // Filter data based on search term
//   const filteredData = data?.filter((item) => {
//     if (!searchTerm) return true;
//     return Object.values(item).some(
//       (value) =>
//         value &&
//         value.toString().toLowerCase().includes(searchTerm.toLowerCase())
//     );
//   }) || [];

//   // Pagination logic
//   const totalPages = Math.ceil(filteredData.length / itemsPerPage);
//   const paginatedData = filteredData.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//   // Handle page change
//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const handleRowClick = (item) => {
//     if (onSelectParcel) {
//       onSelectParcel(selectedParcel === item.parcelNo ? null : item);
//     }
//   };

//   // Fetch parcel report details
//   const fetchParcelReportDetails = (parcelNo) => {
//     setCurrentParcelNo(parcelNo);
//     setLoadingReport(true);
    
//     axios
//       .get(`${backendUrl}ParcelDetails/GetParcelCostDetails?parcelNo=${parcelNo}`)
//       .then((res) => {
//         setReportData(res.data);
//         setShowReportModal(true);
//       })
//       .catch((error) => {
//         console.error("Error fetching parcel report details:", error.message);
//         // Optional: show toast or alert here
//       })
//       .finally(() => {
//         setLoadingReport(false);
//       });
//   };

//   return (
//     <div className="bg-white rounded-lg shadow-md p-4">
//       {/* Search Input */}
//       <div className="mb-4">
//         <input
//           type="text"
//           placeholder="Search bookings..."
//           className="w-full p-2 border border-gray-300 rounded-md"
//           value={searchTerm}
//           onChange={(e) => {
//             setSearchTerm(e.target.value);
//             setCurrentPage(1); // Reset to first page on new search
//           }}
//         />
//       </div>

//       {/* Table */}
//       <div className="overflow-x-auto">
//         <table className="min-w-full divide-y divide-gray-200">
//           <thead className="bg-gray-50">
//             <tr>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Parcel No
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Date
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Sender
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Receiver
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Route
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Cargo Type
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Total Amount
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Payment Status
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Actions
//               </th>
//             </tr>
//           </thead>
//           <tbody className="bg-white divide-y divide-gray-200">
//             {paginatedData.length > 0 ? (
//               paginatedData.map((item, index) => (
//                 <tr 
//                   key={index} 
//                   onClick={() => handleRowClick(item)}
//                   className={`
//                     ${index % 2 === 0 ? "bg-white" : "bg-gray-50"}
//                     ${selectedParcel === item.parcelNo ? "ring-2 ring-orange-500" : ""}
//                     cursor-pointer hover:bg-gray-100 transition-colors
//                   `}
//                 >
//                   <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
//                     {item.parcelNo || "N/A"}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     {formatDate(item.parcelCreationDate)}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     <div className="flex flex-col">
//                       <span className="font-medium">{item.senderName || "N/A"}</span>
//                       <span className="text-gray-400 text-xs">{item.senderEmail || ""}</span>
//                     </div>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     <div className="flex flex-col">
//                       <span className="font-medium">{item.receiverName || "N/A"}</span>
//                       <span className="text-gray-400 text-xs">{item.receiverEmail || ""}</span>
//                     </div>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     {item.routeName || "N/A"}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     {item.cargoTypeName || "N/A"}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     {item.symbol || ""} {item.subTotal || "0"}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap">
//                     <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
//                       ${item.statusName === "Pending" ? "bg-yellow-100 text-yellow-800" : 
//                         item.statusName === "Shipped" ? "bg-blue-100 text-blue-800" : 
//                         "bg-green-100 text-green-800"}`}>
//                       {item.statusName || "N/A"}
//                     </span>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     <button
//                       onClick={(e) => {
//                         e.stopPropagation(); // Prevent row click from triggering
//                         fetchParcelReportDetails(item.parcelNo);
//                       }}
//                       disabled={loadingReport && currentParcelNo === item.parcelNo}
//                       className="text-blue-600 hover:text-blue-800 flex items-center gap-1"
//                     >
//                       <FiFileText className="inline" />
//                       {loadingReport && currentParcelNo === item.parcelNo ? "Loading..." : "Report"}
//                     </button>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="9" className="px-6 py-4 text-center text-sm text-gray-500">
//                   No booking history found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       {totalPages > 1 && (
//         <div className="flex justify-between items-center mt-4">
//           <button
//             onClick={() => handlePageChange(Math.max(1, currentPage - 1))}
//             disabled={currentPage === 1}
//             className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50"
//           >
//             Previous
//           </button>
//           <div className="flex space-x-2">
//             {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
//               <button
//                 key={page}
//                 onClick={() => handlePageChange(page)}
//                 className={`px-4 py-2 border rounded-md text-sm font-medium 
//                   ${currentPage === page 
//                     ? "bg-orange-500 text-white border-orange-500" 
//                     : "border-gray-300 text-gray-700 bg-white hover:bg-gray-50"}`}
//               >
//                 {page}
//               </button>
//             ))}
//           </div>
//           <button
//             onClick={() => handlePageChange(Math.min(totalPages, currentPage + 1))}
//             disabled={currentPage === totalPages}
//             className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50"
//           >
//             Next
//           </button>
//         </div>
//       )}

//       {/* Report Modal */}
//       {showReportModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg p-6 max-w-2xl w-full max-h-[90vh] overflow-y-auto">
//             <div className="flex justify-between items-center mb-4">
//               <h2 className="text-2xl font-bold">Parcel Report Details</h2>
//               <button
//                 onClick={() => setShowReportModal(false)}
//                 className="text-gray-500 hover:text-gray-700"
//               >
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   className="h-6 w-6"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M6 18L18 6M6 6l12 12"
//                   />
//                 </svg>
//               </button>
//             </div>

//             {loadingReport ? (
//               <div className="flex justify-center items-center h-32">
//                 <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
//               </div>
//             ) : (
//               <>
//                 <div className="mb-6">
//                   <h3 className="text-lg font-semibold mb-2">
//                     Parcel Number: {currentParcelNo}
//                   </h3>
//                 </div>

//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
//                   <div className="bg-gray-50 p-4 rounded-lg">
//                     <h4 className="font-medium text-gray-700 mb-2">Sender Information</h4>
//                     <div className="space-y-2">
//                       <div className="flex justify-between">
//                         <span>Name:</span>
//                         <span>{reportData?.senderName || "N/A"}</span>
//                       </div>
//                       <div className="flex justify-between">
//                         <span>Phone:</span>
//                         <span>{reportData?.senderPhone || "N/A"}</span>
//                       </div>
//                       <div className="flex justify-between">
//                         <span>Address:</span>
//                         <span>{reportData?.senderAddress || "N/A"}</span>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="bg-gray-50 p-4 rounded-lg">
//                     <h4 className="font-medium text-gray-700 mb-2">Receiver Information</h4>
//                     <div className="space-y-2">
//                       <div className="flex justify-between">
//                         <span>Name:</span>
//                         <span>{reportData?.receiverName || "N/A"}</span>
//                       </div>
//                       <div className="flex justify-between">
//                         <span>Phone:</span>
//                         <span>{reportData?.receiverPhone || "N/A"}</span>
//                       </div>
//                       <div className="flex justify-between">
//                         <span>Address:</span>
//                         <span>{reportData?.receiverAddress || "N/A"}</span>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="bg-gray-50 p-4 rounded-lg">
//                     <h4 className="font-medium text-gray-700 mb-2">Parcel Details</h4>
//                     <div className="space-y-2">
//                       <div className="flex justify-between">
//                         <span>Weight:</span>
//                         <span>{reportData?.weight || "N/A"} kg</span>
//                       </div>
//                       <div className="flex justify-between">
//                         <span>Dimensions:</span>
//                         <span>{reportData?.dimensions || "N/A"}</span>
//                       </div>
//                       <div className="flex justify-between">
//                         <span>Cargo Type:</span>
//                         <span>{reportData?.cargoTypeName || "N/A"}</span>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="bg-gray-50 p-4 rounded-lg">
//                     <h4 className="font-medium text-gray-700 mb-2">Shipping Information</h4>
//                     <div className="space-y-2">
//                       <div className="flex justify-between">
//                         <span>Route:</span>
//                         <span>{reportData?.routeName || "N/A"}</span>
//                       </div>
//                       <div className="flex justify-between">
//                         <span>Status:</span>
//                         <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
//                           ${reportData?.statusName === "Pending" ? "bg-yellow-100 text-yellow-800" : 
//                             reportData?.statusName === "Shipped" ? "bg-blue-100 text-blue-800" : 
//                             "bg-green-100 text-green-800"}`}>
//                           {reportData?.statusName || "N/A"}
//                         </span>
//                       </div>
//                       <div className="flex justify-between">
//                         <span>Created Date:</span>
//                         <span>{formatDate(reportData?.parcelCreationDate) || "N/A"}</span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="bg-blue-50 p-4 rounded-lg">
//                   <div className="flex justify-between items-center">
//                     <h4 className="font-bold text-lg">Total Amount:</h4>
//                     <span className="text-xl font-bold">
//                       {reportData?.symbol || ""} {reportData?.subTotal || "0"}
//                     </span>
//                   </div>
//                 </div>

//                 <div className="mt-4 bg-gray-50 p-4 rounded-lg">
//                   <h4 className="font-medium text-gray-700 mb-2">Additional Notes</h4>
//                   <p className="text-gray-600">
//                     {reportData?.notes || "No additional notes available."}
//                   </p>
//                 </div>
//               </>
//             )}

//             <div className="mt-6 flex justify-end">
//               <button
//                 onClick={() => setShowReportModal(false)}
//                 className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
//               >
//                 Close
//               </button>
//               {/* <button
//                 onClick={() => {
                 
//                   window.print();
//                 }}
//                 className="ml-2 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition-colors"
//               >
//                 Print Report
//               </button> */}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default BookingHistoryTable;















// import React, { useState, useRef } from "react";
// import { format } from "date-fns";
// import { FiFileText, FiDownload } from "react-icons/fi";
// import axios from "axios";
// import { usePDF } from 'react-to-pdf';

// const BookingHistoryTable = ({ data, onSelectParcel, selectedParcel }) => {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [showReportModal, setShowReportModal] = useState(false);
//   const [parcelData, setParcelData] = useState(null);
//   const [costData, setCostData] = useState(null);
//   const [loadingReport, setLoadingReport] = useState(false);
//   const backendUrl = process.env.REACT_APP_API_URL;
  
//   const itemsPerPage = 10;
//   const { toPDF, targetRef } = usePDF({ 
//     filename: `parcel-receipt-${parcelData?.parcelNo || 'receipt'}.pdf`,
//     page: { margin: 10 }
//   });

//   const formatDate = (dateString) => {
//     try {
//       return format(new Date(dateString), "dd/MM/yyyy");
//     } catch {
//       return "N/A";
//     }
//   };

//   const filteredData = data?.filter((item) => {
//     if (!searchTerm) return true;
//     return Object.values(item).some(
//       (value) =>
//         value &&
//         value.toString().toLowerCase().includes(searchTerm.toLowerCase())
//     );
//   }) || [];

//   const totalPages = Math.ceil(filteredData.length / itemsPerPage);
//   const paginatedData = filteredData.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const handleRowClick = (item) => {
//     if (onSelectParcel) {
//       onSelectParcel(selectedParcel === item.parcelNo ? null : item);
//     }
//   };
// console.log(parcelData)
//   const fetchParcelReportDetails = (parcel) => {
//     setParcelData(parcel);
//     setLoadingReport(true);
    
//     axios
//       .get(`${backendUrl}ParcelDetails/GetParcelCostDetails?parcelNo=${parcel.parcelNo}`)
//       .then((res) => {
//         setCostData(res.data);
//         setShowReportModal(true);
//       })
//       .catch((error) => {
//         console.error("Error fetching parcel report details:", error.message);
//         // Optional: show toast or alert here
//       })
//       .finally(() => {
//         setLoadingReport(false);
//       });
//   };
// const statusColors = {
//     pending: {
//       bg: 'bg-yellow-100', // was oklch()
//       text: 'text-yellow-800'
//     },
//     completed: {
//       bg: 'bg-green-100', // was oklch()
//       text: 'text-green-800'
//     }
//   };
  

//   const generateReceipt = () => {
//     if (!parcelData) return null;

//     const totalAmount = (costData?.subTotal || 0) + (costData?.vaT_TaxAmount || 0);

//     return (
//      <div ref={targetRef} className="p-4" style={{
//         width: '794px',
//         fontFamily: 'Arial, sans-serif',
//         fontSize: '14px',
//         color: '#333333' // Standard hex instead of oklch()
//       }}>
//         {/* Header with standard colors */}
//         <div className="text-center mb-4">
//           {/* <h1 className="text-2xl font-bold" style={{ color: '#222' }}>Parcel Receipt</h1> */}
//           <h1 className="text-2xl font-bold" style={{ color: '#222222' }}>
//             Parcel Receipt
//           </h1>
//           <div className="flex justify-between text-sm mt-2" style={{ color: 'black' }}>
//             <p>Date: {format(new Date(), "dd/MM/yyyy HH:mm")}</p>
//             <p>Receipt No: {parcelData.parcelNo}</p>
//           </div>
//         </div>

//         {/* Sender/Receiver Info */}
//         <div className="grid grid-cols-2 gap-4 mb-4">
//           <div className="border p-2">
//             <h3 className="font-bold border-b pb-1">Sender</h3>
//             <p className="mt-1"><span className="font-semibold">Name:</span> {parcelData.senderName || "N/A"}</p>
//             <p><span className="font-semibold">Email:</span> {parcelData.senderEmail || "N/A"}</p>
//           </div>
//           <div className="border p-2">
//             <h3 className="font-bold border-b pb-1">Receiver</h3>
//             <p className="mt-1"><span className="font-semibold">Name:</span> {parcelData.receiverName || "N/A"}</p>
//             <p><span className="font-semibold">Email:</span> {parcelData.receiverEmail || "N/A"}</p>
//           </div>
//         </div>

//         {/* Parcel Details */}
//         <div className="border p-2 mb-4">
//           <h3 className="font-bold border-b pb-1">Parcel Information</h3>
//           <div className="grid grid-cols-3 gap-2 mt-1">
//             <p><span className="font-semibold">Route:</span> {parcelData.routeName || "N/A"}</p>
//             <p><span className="font-semibold">Cargo Type:</span> {parcelData.cargoTypeName || "N/A"}</p>
//             <p><span className="font-semibold">Status:</span> {parcelData.statusName || "N/A"}</p>
//             <p><span className="font-semibold">Dimension:</span> {parcelData.dimensionName || "N/A"}</p>
//             <p><span className="font-semibold">Weight:</span> {parcelData.weightDescription || "N/A"}</p>
//             <p><span className="font-semibold">Created:</span> {formatDate(parcelData.parcelCreationDate)}</p>
//           </div>
//         </div>

//         {/* Cost Breakdown */}
//         <div className="border p-2 mb-4">
//           <h3 className="font-bold border-b pb-1">Payment Details</h3>
//           <table className="w-full mt-1">
//             <tbody>
//               {costData?.weightCost !== undefined && (
//                 <tr>
//                   <td className="font-semibold">Weight Cost:</td>
//                   <td className="text-right">{parcelData.symbol} {costData.weightCost || 0}</td>
//                 </tr>
//               )}
//               {costData?.dimensionCost !== undefined && (
//                 <tr>
//                   <td className="font-semibold">Dimension Cost:</td>
//                   <td className="text-right">{parcelData.symbol} {costData.dimensionCost || 0}</td>
//                 </tr>
//               )}
//               {costData?.routeCost !== undefined && (
//                 <tr>
//                   <td className="font-semibold">Route Cost:</td>
//                   <td className="text-right">{parcelData.symbol} {costData.routeCost || 0}</td>
//                 </tr>
//               )}
//               {costData?.vaT_TaxAmount !== undefined && (
//                 <tr>
//                   <td className="font-semibold">VAT Tax:</td>
//                   <td className="text-right">{parcelData.symbol} {costData.vaT_TaxAmount || 0}</td>
//                 </tr>
//               )}
//               <tr className="border-t">
//                 <td className="font-bold">Subtotal:</td>
//                 <td className="text-right font-bold">{parcelData.symbol} {costData?.subTotal || parcelData.subTotal || 0}</td>
//               </tr>
//               <tr className="border-t-2">
//                 <td className="font-bold text-lg">Total Amount:</td>
//                 <td className="text-right font-bold text-lg">{parcelData.symbol} {totalAmount}</td>
//               </tr>
//               <tr>
//                 <td className="font-bold">Payment Status:</td>
//                 <td className="text-right">
//                   <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
//                     ${parcelData.statusName === "Pending" ? "bg-yellow-100 text-yellow-800" : 
//                       "bg-green-100 text-green-800"}`}>
//                     {parcelData.statusName || "N/A"}
//                   </span>
//                 </td>
//               </tr>
//             </tbody>
//           </table>
//         </div>

//         {/* Footer */}
//         <div className="text-center text-xs mt-6">
//           <p>Thank you for using our service</p>
//           <p className="mt-1">For any queries, please contact our customer support</p>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="bg-white rounded-lg shadow-md p-4">
//       {/* Search Input */}
//       <div className="mb-4">
//         <input
//           type="text"
//           placeholder="Search bookings..."
//           className="w-full p-2 border border-gray-300 rounded-md"
//           value={searchTerm}
//           onChange={(e) => {
//             setSearchTerm(e.target.value);
//             setCurrentPage(1);
//           }}
//         />
//       </div>

//       {/* Table */}
//       <div className="overflow-x-auto">
//         <table className="min-w-full divide-y divide-gray-200">
//           <thead className="bg-gray-50">
//             <tr>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Parcel No</th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Sender</th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Receiver</th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Route</th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Receipt</th>
//             </tr>
//           </thead>
//           <tbody className="bg-white divide-y divide-gray-200">
//             {paginatedData.length > 0 ? (
//               paginatedData.map((item, index) => (
//                 <tr 
//                   key={index} 
//                   onClick={() => handleRowClick(item)}
//                   className={`${index % 2 === 0 ? "bg-white" : "bg-gray-50"} ${
//                     selectedParcel === item.parcelNo ? "ring-2 ring-orange-500" : ""
//                   } cursor-pointer hover:bg-gray-100`}
//                 >
//                   <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
//                     {item.parcelNo || "N/A"}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     {formatDate(item.parcelCreationDate)}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     {item.senderName || "N/A"}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     {item.receiverName || "N/A"}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     {item.routeName || "N/A"}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     {formatCurrency(item.subTotal || 0, item.symbol || "GBP")}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap">
//                     <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
//                       ${item.statusName === "Pending" ? "bg-yellow-100 text-yellow-800" : 
//                         "bg-green-100 text-green-800"}`}>
//                       {item.statusName || "N/A"}
//                     </span>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     <button
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         fetchParcelReportDetails(item);
//                       }}
//                       disabled={loadingReport && parcelData?.parcelNo === item.parcelNo}
//                       className="text-blue-600 hover:text-blue-800 flex items-center gap-1"
//                     >
//                       <FiFileText className="inline" />
//                       {loadingReport && parcelData?.parcelNo === item.parcelNo ? "Loading..." : "Download"}
//                     </button>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="8" className="px-6 py-4 text-center text-sm text-gray-500">
//                   No booking history found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       {totalPages > 1 && (
//         <div className="flex justify-between items-center mt-4">
//           <button
//             onClick={() => handlePageChange(Math.max(1, currentPage - 1))}
//             disabled={currentPage === 1}
//             className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50"
//           >
//             Previous
//           </button>
//           <div className="flex space-x-2">
//             {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
//               <button
//                 key={page}
//                 onClick={() => handlePageChange(page)}
//                 className={`px-4 py-2 border rounded-md text-sm font-medium ${
//                   currentPage === page 
//                     ? "bg-orange-500 text-white border-orange-500" 
//                     : "border-gray-300 text-gray-700 bg-white hover:bg-gray-50"
//                 }`}
//               >
//                 {page}
//               </button>
//             ))}
//           </div>
//           <button
//             onClick={() => handlePageChange(Math.min(totalPages, currentPage + 1))}
//             disabled={currentPage === totalPages}
//             className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50"
//           >
//             Next
//           </button>
//         </div>
//       )}

//       {/* Receipt Modal */}
//       {showReportModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg p-6 max-w-2xl w-full max-h-[90vh] overflow-y-auto">
//             <div className="flex justify-between items-center mb-4">
//               <h2 className="text-2xl font-bold">Parcel Receipt</h2>
//               <div className="flex gap-2">
//                 <button
//                   onClick={() => toPDF()}
//                   className="flex items-center gap-1 px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
//                 >
//                   <FiDownload /> Download PDF
//                 </button>
//                 <button
//                   onClick={() => setShowReportModal(false)}
//                   className="text-gray-500 hover:text-gray-700"
//                 >
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="h-6 w-6"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M6 18L18 6M6 6l12 12"
//                     />
//                   </svg>
//                 </button>
//               </div>
//             </div>

//             {loadingReport ? (
//               <div className="flex justify-center items-center h-32">
//                 <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
//               </div>
//             ) : (
//               generateReceipt()
//             )}

//             <div className="mt-6 flex justify-end">
//               <button
//                 onClick={() => setShowReportModal(false)}
//                 className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700 transition-colors"
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default BookingHistoryTable;








import React, { useContext, useEffect, useMemo, useState, useRef } from "react";
import { format } from "date-fns";
import { FiEye, FiFileText, FiDownload, FiChevronDown } from "react-icons/fi";
import axios from "axios";
import { toast } from "react-toastify";
import { usePDF } from 'react-to-pdf';
import { formatCurrency } from "../../../../utils/formatCurrency";
import { Icon } from "@iconify/react";
import {
  getInvoicesByParcelId,
  getInvoiceForPrint,
  getPaymentByInvoiceNo,
  getPaymentHistoryByParcelId,
} from "../../../../api/invoiceManagerApi";
import {
  fetchParcelCostDetails,
  fetchParcelBookingByParcelNo,
  fetchParcelProductsForEdit,
} from "../../../../api/adminEditBookingApi";
import { getCarrierPartnersByParcelId } from "../../../../api/carrierPartnerApi";
import {
  buildInvoiceSlipFromPrintPayload,
  extractPrintMeasurements,
  describeMeasurementChange,
} from "../../../../utils/invoiceManagerSlip";
import {
  dedupeBookingHistoryByParcel,
  pickLatestInvoice,
  invoiceNumberOf,
  buildParcelAmendments,
} from "../../../../utils/bookingHistory";
import { MANUAL_PAYMENT_TYPE_ID } from "../../../../utils/manualPayment";
import { contextProvider } from "../../../setupPage/SetupPagesContextApi/SetupPagesContextApi";
import VerticalProgressBar from "./VerticalProgressBar";
import PaymentHistoryTimeline, {
  paymentStatusBadgeClass,
} from "../../../sharedComponents/PaymentHistoryTimeline";
import AmendmentDetailsPanel from "../../../sharedComponents/AmendmentDetailsPanel";
import MeasurementCompare from "../../../sharedComponents/MeasurementCompare";
import CarrierPartnerPanel from "../../../sharedComponents/CarrierPartnerPanel";

const REFUND_WHATSAPP_CONTACTS = [
  { label: "01723925785", waId: "8801723925785" },
  { label: "+44 7775 318440", waId: "447775318440" },
];

const buildRefundWhatsAppUrl = (waId, parcel) => {
  const message = encodeURIComponent(
    `Hello, I would like to request a refund for parcel #${parcel?.parcelNo || "N/A"}.`,
  );
  return `https://wa.me/${waId}?text=${message}`;
};

const pickDetail = (...values) => {
  for (const v of values) {
    if (v != null && String(v).trim() !== "") return v;
  }
  return "";
};

const formatPaymentDate = (value) => {
  if (!value) return "";
  try {
    return format(new Date(value), "dd MMM yyyy, HH:mm");
  } catch {
    return String(value);
  }
};

const resolvePaymentMethodLabel = (...sources) => {
  for (const src of sources) {
    if (!src || typeof src !== "object") continue;
    const named = pickDetail(
      src.paymentMethodName,
      src.PaymentMethodName,
      src.paymentTypeName,
      src.paymentTypeMethodName,
    );
    if (named) return named;

    const id = pickDetail(
      src.paymentMethodId,
      src.paymentTypeMethodId,
      src.paymentTypeId,
      src.PaymentMethodId,
    );
    if (id === "" || id == null) continue;
    const s = String(id);
    if (s === "1") return "Cash";
    if (s === "2") return "Online Payment";
    if (s === String(MANUAL_PAYMENT_TYPE_ID) || s === "5") return "Bank Payment";
  }
  return "";
};

const hasPaymentDetails = (details) => {
  if (!details) return false;
  return Boolean(
    pickDetail(
      details.paymentMethodName,
      details.paymentInvoiceNo,
      details.paymentDate,
      details.cardLast4,
      details.cardBrand,
      details.stripePaymentIntentId,
      details.stripeChargeId,
      details.paymentDescription,
      details.paidAmount,
    ),
  );
};

const paymentHistoryItems = (details) => {
  const items = details?.paymentHistory?.items;
  return Array.isArray(items) ? items : [];
};

const DetailRow = ({ label, value }) => (
  <div className="grid grid-cols-1 sm:grid-cols-[6.5rem_minmax(0,1fr)] gap-0.5 sm:gap-2 py-1.5 border-b border-stone-100 last:border-0">
    <span className="text-xs font-semibold uppercase tracking-wide text-stone-500">
      {label}
    </span>
    <span className="text-sm text-stone-900 break-words break-all min-w-0">
      {value || "—"}
    </span>
  </div>
);

const rowPaymentStatus = (item, detailsForRow) =>
  pickDetail(
    detailsForRow?.paymentHistory?.paymentStatus,
    detailsForRow?.paymentStatusName,
    item?.paymentStatus,
    item?.statusName,
  );

const paginationItems = (current, total, siblingCount = 1) => {
  if (total <= 7) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }
  const pages = new Set([1, total, current]);
  for (let i = 1; i <= siblingCount; i += 1) {
    if (current - i >= 1) pages.add(current - i);
    if (current + i <= total) pages.add(current + i);
  }
  const sorted = [...pages].sort((a, b) => a - b);
  const items = [];
  sorted.forEach((page, idx) => {
    if (idx > 0 && page - sorted[idx - 1] > 1) items.push(`gap-${page}`);
    items.push(page);
  });
  return items;
};

const BookingHistoryTable = ({
  data,
  onSelectParcel,
  selectedParcel,
  parcelStatusData,
  statusLoading,
  embedded = false,
  showRefund = true,
  showAmendmentDetails = false,
  showCarrierPartner = false,
}) => {
  const ctx = useContext(contextProvider) || {};
  const lookups = useMemo(
    () => ({
      itemCategories: ctx.itemCategory || [],
      itemTypes: ctx.itemType || [],
      cargoTypes: ctx.cargoTypes || [],
      dimensions: ctx.dimensions || [],
      weights: ctx.weight || [],
    }),
    [ctx.itemCategory, ctx.itemType, ctx.cargoTypes, ctx.dimensions, ctx.weight],
  );

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showReportModal, setShowReportModal] = useState(false);
  const [showRefundModal, setShowRefundModal] = useState(false);
  const [refundParcel, setRefundParcel] = useState(null);
  const [viewParcel, setViewParcel] = useState(null);
  const [viewDetails, setViewDetails] = useState(null);
  const [loadingView, setLoadingView] = useState(false);
  const [parcelData, setParcelData] = useState(null);
  const [costData, setCostData] = useState(null);
  const [loadingReport, setLoadingReport] = useState(false);
  const backendUrl = process.env.REACT_APP_API_URL;
  
  const itemsPerPage = 10;
  const { toPDF, targetRef } = usePDF({ 
    filename: `parcel-receipt-${parcelData?.parcelNo || 'receipt'}.pdf`,
    page: { margin: 10 }
  });

  // One row per parcel — API returns a row per invoice version after remesaure.
  const uniqueParcels = useMemo(
    () => dedupeBookingHistoryByParcel(data),
    [data],
  );

  const formatDate = (dateString) => {
    try {
      return format(new Date(dateString), "dd/MM/yyyy");
    } catch {
      return "N/A";
    }
  };

  const filteredData = uniqueParcels.filter((item) => {
    if (!searchTerm) return true;
    return Object.values(item).some(
      (value) =>
        value &&
        value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    if (totalPages > 0 && currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages]);

  const handleRowClick = (item) => {
    toggleAccordion(item);
  };

  const openRefundModal = (e, parcel) => {
    e.stopPropagation();
    setRefundParcel(parcel);
    setShowRefundModal(true);
  };

  const closeRefundModal = () => {
    setShowRefundModal(false);
    setRefundParcel(null);
  };

  const clearAccordionDetails = () => {
    setViewParcel(null);
    setViewDetails(null);
    setLoadingView(false);
  };

  const resolveLocationName = (list, id) => {
    if (id == null || id === "") return "";
    if (Number.isNaN(Number(id))) return String(id);
    const row = (Array.isArray(list) ? list : []).find(
      (x) => Number(x.id) === Number(id),
    );
    return row?.name || row?.cityName || row?.countryName || "";
  };

  const buildPartyAddress = (role, sources, cities, countries) => {
    const door = pickDetail(
      ...sources.map((s) => s?.[`${role}DoorNo`]),
      ...sources.map(
        (s) =>
          s?.[`${role.charAt(0).toUpperCase()}${role.slice(1)}DoorNo`],
      ),
    );
    const street = pickDetail(
      ...sources.map((s) => s?.[`${role}StreetName`]),
      ...sources.map(
        (s) =>
          s?.[`${role.charAt(0).toUpperCase()}${role.slice(1)}StreetName`],
      ),
    );
    const additional = pickDetail(
      ...sources.map((s) => s?.[`${role}AdditionalAddressInfo`]),
      ...sources.map(
        (s) =>
          s?.[
            `${role.charAt(0).toUpperCase()}${role.slice(1)}AdditionalAddressInfo`
          ],
      ),
      ...sources.map((s) => s?.[`${role}Address`]),
    );
    const postcode = pickDetail(
      ...sources.map((s) => s?.[`${role}PostCode`]),
      ...sources.map(
        (s) =>
          s?.[`${role.charAt(0).toUpperCase()}${role.slice(1)}PostCode`],
      ),
    );
    const cityId = pickDetail(
      ...sources.map((s) => s?.[`${role}CityId`]),
      ...sources.map(
        (s) => s?.[`${role.charAt(0).toUpperCase()}${role.slice(1)}CityId`],
      ),
      ...sources.map((s) => s?.[`${role}City`]),
    );
    const countryId = pickDetail(
      ...sources.map((s) => s?.[`${role}CountryId`]),
      ...sources.map(
        (s) =>
          s?.[`${role.charAt(0).toUpperCase()}${role.slice(1)}CountryId`],
      ),
      ...sources.map((s) => s?.[`${role}Country`]),
    );
    const cityName =
      resolveLocationName(cities, cityId) ||
      pickDetail(
        ...sources.map((s) => s?.[`${role}CityName`]),
        Number.isNaN(Number(cityId)) ? cityId : "",
      );
    const countryName =
      resolveLocationName(countries, countryId) ||
      pickDetail(
        ...sources.map((s) => s?.[`${role}CountryName`]),
        Number.isNaN(Number(countryId)) ? countryId : "",
      );

    const line1 = [door, street].filter(Boolean).join(", ");
    const parts = [];
    if (line1) parts.push(line1);
    if (
      additional &&
      additional !== door &&
      additional !== street &&
      additional !== line1
    ) {
      parts.push(additional);
    }
    if (postcode) parts.push(postcode);
    const location = [cityName, countryName].filter(Boolean).join(", ");
    if (location) parts.push(location);
    return parts.length ? parts.join(" · ") : "";
  };

  const loadParcelDetails = async (parcel) => {
    const parcelId = parcel?.parcelNo ?? parcel?.parcelId;
    setViewParcel(parcel);
    setViewDetails(null);
    setLoadingView(true);

    try {
      const [invoices, historyRow, cost, countriesRes, citiesRes, statusRes, liveProducts, carrierPartners] =
        await Promise.all([
          parcelId != null
            ? getInvoicesByParcelId(parcelId).catch(() => [])
            : Promise.resolve([]),
          parcelId != null
            ? fetchParcelBookingByParcelNo(parcelId).catch(() => null)
            : Promise.resolve(null),
          parcelId != null
            ? fetchParcelCostDetails(parcelId).catch(() => ({}))
            : Promise.resolve({}),
          axios.get(`${backendUrl}Country`).catch(() => ({ data: [] })),
          axios.get(`${backendUrl}city`).catch(() => ({ data: [] })),
          parcelId != null
            ? axios
                .get(
                  `${backendUrl}ParcelStatus/GetParcelStatusRankByParcelId?parcelId=${parcelId}`,
                )
                .catch(() => ({ data: [] }))
            : Promise.resolve({ data: [] }),
          showAmendmentDetails && parcelId != null
            ? fetchParcelProductsForEdit(parcelId).catch(() => [])
            : Promise.resolve([]),
          showCarrierPartner && parcelId != null
            ? getCarrierPartnersByParcelId(parcelId).catch(() => [])
            : Promise.resolve([]),
        ]);

      const countries = Array.isArray(countriesRes?.data)
        ? countriesRes.data
        : [];
      const cities = Array.isArray(citiesRes?.data) ? citiesRes.data : [];

      const latest = pickLatestInvoice(invoices);
      const latestInvoiceNo = invoiceNumberOf(latest);
      const invoiceList = Array.isArray(invoices) ? invoices : [];
      const extraAmendmentNos = showAmendmentDetails
        ? [
            ...new Set(
              invoiceList
                .map(invoiceNumberOf)
                .filter((no) => no && no !== latestInvoiceNo),
            ),
          ].slice(0, 8)
        : [];
      const [printPayload, paymentDetail, paymentHistory, ...extraPrints] =
        await Promise.all([
          latestInvoiceNo
            ? getInvoiceForPrint(latestInvoiceNo).catch(() => null)
            : Promise.resolve(null),
          latestInvoiceNo
            ? getPaymentByInvoiceNo(latestInvoiceNo).catch(() => null)
            : Promise.resolve(null),
          parcelId != null
            ? getPaymentHistoryByParcelId(parcelId).catch(() => null)
            : Promise.resolve(null),
          ...extraAmendmentNos.map((no) =>
            getInvoiceForPrint(no).catch(() => null),
          ),
        ]);

      const printByInvoiceNo = {};
      if (latestInvoiceNo && printPayload && typeof printPayload === "object") {
        printByInvoiceNo[latestInvoiceNo] = printPayload;
      }
      extraAmendmentNos.forEach((no, idx) => {
        const payload = extraPrints[idx];
        if (no && payload && typeof payload === "object") {
          printByInvoiceNo[no] = payload;
        }
      });

      const measurementsByInvoiceNo = {};
      Object.entries(printByInvoiceNo).forEach(([no, payload]) => {
        const meas = extractPrintMeasurements(payload, lookups, parcelId);
        if (meas) measurementsByInvoiceNo[no] = meas;
      });

      const liveMeasurements = extractPrintMeasurements(
        { lines: Array.isArray(liveProducts) ? liveProducts : [] },
        lookups,
        parcelId,
      );
      const latestMeasurements =
        measurementsByInvoiceNo[latestInvoiceNo] ||
        extractPrintMeasurements(printPayload, lookups, parcelId);
      const currentMeasurements = {
        customerInput:
          liveMeasurements?.customerInput ||
          latestMeasurements?.customerInput ||
          null,
        hubMeasurement:
          liveMeasurements?.hubMeasurement ||
          latestMeasurements?.hubMeasurement ||
          null,
        weightBandName:
          liveMeasurements?.weightBandName ||
          latestMeasurements?.weightBandName ||
          "",
        dimensionName:
          liveMeasurements?.dimensionName ||
          latestMeasurements?.dimensionName ||
          "",
      };

      const amendments = (
        showAmendmentDetails
          ? buildParcelAmendments({
              invoices: invoiceList,
              printByInvoiceNo,
              paymentHistory,
            })
          : []
      ).map((row) => {
        const meas =
          measurementsByInvoiceNo[row.paymentInvoiceNo] || currentMeasurements;
        const parentMeas = row.parentInvoiceNo
          ? measurementsByInvoiceNo[row.parentInvoiceNo]
          : null;
        const previous =
          parentMeas?.hubMeasurement || parentMeas?.customerInput || null;
        const changeTo = meas?.hubMeasurement || null;
        return {
          ...row,
          customerInput: meas?.customerInput || currentMeasurements.customerInput,
          hubMeasurement: meas?.hubMeasurement || currentMeasurements.hubMeasurement,
          weightBandName: meas?.weightBandName || currentMeasurements.weightBandName,
          dimensionName: meas?.dimensionName || currentMeasurements.dimensionName,
          previousMeasurement: previous,
          changeSummary:
            describeMeasurementChange(previous, changeTo) ||
            describeMeasurementChange(meas?.customerInput, changeTo),
        };
      });

      const amendmentByInvoice = new Map(
        amendments
          .filter((row) => row.paymentInvoiceNo)
          .map((row) => [row.paymentInvoiceNo, row]),
      );
      const enrichedPaymentHistory =
        paymentHistory && typeof paymentHistory === "object"
          ? {
              ...paymentHistory,
              items: (Array.isArray(paymentHistory.items)
                ? paymentHistory.items
                : []
              ).map((item) => {
                const extra = amendmentByInvoice.get(invoiceNumberOf(item));
                if (!extra) return item;
                return {
                  ...item,
                  description: item.description || extra.why,
                  creationDate: item.creationDate || extra.when,
                };
              }),
            }
          : null;

      const historyObj =
        historyRow && typeof historyRow === "object" ? historyRow : {};
      const printObj =
        printPayload && typeof printPayload === "object" ? printPayload : {};
      const costObj = cost && typeof cost === "object" ? cost : {};
      const payObj =
        paymentDetail && typeof paymentDetail === "object" ? paymentDetail : {};

      const statusRows = Array.isArray(statusRes?.data) ? statusRes.data : [];
      // GetParcelStatusRankByParcelId returns the full route timeline (all ranks),
      // NOT "current only". Never pick max(rank) — that always yields the last step
      // (e.g. "Out For BD Delivery"). Prefer the parcel's stored current status.
      const explicitCurrent = statusRows.find(
        (s) =>
          s?.isCurrent === true ||
          s?.IsCurrent === true ||
          s?.isCurrentStatus === true,
      );
      const completedOnly = statusRows.filter(
        (s) =>
          s?.isCompleted === true ||
          s?.IsCompleted === true ||
          s?.completed === true,
      );
      const latestCompleted =
        completedOnly.length > 0
          ? [...completedOnly].sort(
              (a, b) =>
                Number(b.rank ?? b.Rank ?? 0) - Number(a.rank ?? a.Rank ?? 0),
            )[0]
          : null;

      const parcelStatusName = pickDetail(
        historyObj.currentParcelStatusName,
        historyObj.CurrentParcelStatusName,
        parcel.currentParcelStatusName,
        parcel.CurrentParcelStatusName,
        explicitCurrent?.parcelStatusName,
        explicitCurrent?.ParcelStatusName,
        latestCompleted?.parcelStatusName,
        latestCompleted?.ParcelStatusName,
      );

      const sources = [printObj, payObj, historyObj, costObj, parcel];

      const paymentMethodName = resolvePaymentMethodLabel(
        printObj,
        payObj,
        latest,
        historyObj,
        costObj,
        parcel,
      );

      const cardLast4 = pickDetail(
        payObj.cardLast4,
        printObj.cardLast4,
        historyObj.cardLast4,
        parcel.cardLast4,
      );
      const cardBrand = pickDetail(
        payObj.cardBrand,
        printObj.cardBrand,
        historyObj.cardBrand,
        parcel.cardBrand,
      );

      setViewDetails({
        parcelNo: parcelId,
        senderName: pickDetail(
          printObj.senderName,
          historyObj.senderName,
          parcel.senderName,
        ),
        senderEmail: pickDetail(
          printObj.senderEmail,
          historyObj.senderEmail,
          parcel.senderEmail,
        ),
        senderPhone: pickDetail(
          printObj.senderPhone,
          printObj.SenderPhone,
          historyObj.senderPhone,
          historyObj.senderMobileNo,
          costObj.senderPhone,
          costObj.senderMobileNo,
          parcel.senderPhone,
        ),
        senderAddress: buildPartyAddress("sender", sources, cities, countries),
        receiverName: pickDetail(
          printObj.receiverName,
          historyObj.receiverName,
          parcel.receiverName,
        ),
        receiverEmail: pickDetail(
          printObj.receiverEmail,
          historyObj.receiverEmail,
          parcel.receiverEmail,
        ),
        receiverPhone: pickDetail(
          printObj.receiverPhone,
          printObj.ReceiverPhone,
          historyObj.receiverPhone,
          historyObj.receiverMobileNo,
          costObj.receiverPhone,
          costObj.receiverMobileNo,
          parcel.receiverPhone,
        ),
        receiverAddress: buildPartyAddress(
          "receiver",
          sources,
          cities,
          countries,
        ),
        routeName: pickDetail(
          historyObj.routeName,
          parcel.routeName,
          costObj.routeName,
        ),
        cargoTypeName: pickDetail(
          historyObj.cargoTypeName,
          parcel.cargoTypeName,
        ),
        weightDescription: pickDetail(
          currentMeasurements.weightBandName,
          historyObj.weightDescription,
          parcel.weightDescription,
        ),
        dimensionName: pickDetail(
          currentMeasurements.dimensionName,
          historyObj.dimensionName,
          parcel.dimensionName,
        ),
        measurements: currentMeasurements,
        recordSerialNo: pickDetail(
          printObj.recordSerialNo,
          printObj.RecordSerialNo,
          historyObj.recordSerialNo,
          costObj.recordSerialNo,
          parcel.recordSerialNo,
        ),
        barcode: pickDetail(
          printObj.barcode,
          printObj.Barcode,
          historyObj.barcode,
          costObj.barcode,
        ),
        subTotal: pickDetail(
          latest?.orderAmount,
          printObj.orderAmount,
          historyObj.subTotal,
          costObj.subTotal,
          parcel.subTotal,
        ),
        orderPayableAmount: pickDetail(
          latest?.orderAmount,
          printObj.orderAmount,
          payObj.orderAmount,
          historyObj.orderPayableAmount,
          costObj.orderPayableAmount,
          parcel.orderPayableAmount,
          parcel.subTotal,
        ),
        symbol: pickDetail(
          latest?.currencySymbol,
          latest?.symbol,
          printObj.currencySymbol,
          payObj.symbol,
          payObj.currencySymbol,
          historyObj.symbol,
          parcel.symbol,
          "GBP",
        ),
        paymentStatusName: pickDetail(
          paymentHistory?.paymentStatus,
          historyObj.paymentStatus,
          parcel.paymentStatus,
          latest?.statusName,
          printObj.statusName,
          payObj.statusName,
          historyObj.statusName,
          parcel.statusName,
        ),
        currentParcelStatusName: parcelStatusName,
        latestInvoiceNo,
        latestInvoiceStatus: pickDetail(
          latest?.statusName,
          latest?.StatusName,
        ),
        invoiceCount: Array.isArray(invoices) ? invoices.length : 0,
        parcelCreationDate: pickDetail(
          historyObj.parcelCreationDate,
          parcel.parcelCreationDate,
          printObj.creationDate,
        ),
        uniqItemDescription: pickDetail(
          historyObj.uniqItemDescription,
          parcel.uniqItemDescription,
        ),
        shippingServiceName: pickDetail(
          historyObj.shippingServiceName,
          parcel.shippingServiceName,
        ),
        // Payment details (shown when present)
        paymentInvoiceNo: pickDetail(
          latestInvoiceNo,
          printObj.paymentInvoiceNo,
          payObj.paymentInvoiceNo,
          payObj.invoiceNumber,
        ),
        paymentMethodName,
        paymentDate: pickDetail(
          printObj.paymentDate,
          payObj.paymentDate,
          payObj.paidDate,
          historyObj.paymentDate,
          latest?.paymentDate,
          latest?.creationDate,
          printObj.creationDate,
        ),
        paidAmount: pickDetail(
          payObj.orderAmount,
          printObj.orderAmount,
          latest?.orderAmount,
        ),
        paymentDescription: pickDetail(
          printObj.description,
          payObj.description,
          latest?.description,
        ),
        cardBrand,
        cardLast4,
        stripePaymentIntentId: pickDetail(
          payObj.stripePaymentIntentId,
          printObj.stripePaymentIntentId,
          historyObj.stripePaymentIntentId,
          parcel.stripePaymentIntentId,
        ),
        stripeChargeId: pickDetail(
          payObj.stripeChargeId,
          printObj.stripeChargeId,
          historyObj.stripeChargeId,
          parcel.stripeChargeId,
        ),
        stripePaymentMethod: pickDetail(
          payObj.stripePaymentMethod,
          printObj.stripePaymentMethod,
          historyObj.stripePaymentMethod,
        ),
        paymentHistory: enrichedPaymentHistory,
        amendments,
        carrierPartners: Array.isArray(carrierPartners) ? carrierPartners : [],
      });
    } catch (err) {
      console.error("Failed to load parcel details", err);
      toast.error(
        err?.response?.data?.message ||
          err?.message ||
          "Could not load parcel details.",
      );
      setViewDetails({
        ...parcel,
        senderAddress: "",
        receiverAddress: "",
        paymentStatusName: parcel.statusName,
      });
    } finally {
      setLoadingView(false);
    }
  };

  const toggleAccordion = (item) => {
    const isOpen = selectedParcel === item.parcelNo;
    if (isOpen) {
      if (onSelectParcel) onSelectParcel(null);
      clearAccordionDetails();
      return;
    }
    if (onSelectParcel) onSelectParcel(item);
    loadParcelDetails(item);
  };

  const openViewAccordion = (e, parcel) => {
    e.stopPropagation();
    toggleAccordion(parcel);
  };

  const viewAmount = (row) =>
    formatCurrency(
      row?.orderPayableAmount ??
        row?.subTotal ??
        row?.SubTotal ??
        viewParcel?.subTotal ??
        viewParcel?.orderPayableAmount ??
        0,
      row?.symbol || viewParcel?.symbol || "GBP",
    );

  const openLegacyReceipt = (parcel) => {
    setParcelData(parcel);
    setLoadingReport(true);
    axios
      .get(
        `${backendUrl}ParcelDetails/GetParcelCostDetails?parcelNo=${parcel.parcelNo}`,
      )
      .then((res) => {
        setCostData(res.data);
        setShowReportModal(true);
      })
      .catch((error) => {
        console.error("Error fetching parcel report details:", error.message);
        toast.error("Could not open parcel receipt.");
      })
      .finally(() => {
        setLoadingReport(false);
      });
  };

  /** Download / open only the latest (current) invoice for this parcel. */
  const downloadLatestInvoice = async (parcel) => {
    const parcelId = parcel?.parcelNo ?? parcel?.parcelId;
    if (parcelId == null || parcelId === "") {
      toast.error("Parcel number is missing.");
      return;
    }

    setParcelData(parcel);
    setLoadingReport(true);
    let useLegacyReceipt = false;
    try {
      const invoices = await getInvoicesByParcelId(parcelId);
      const latest = pickLatestInvoice(invoices);
      const latestInvoiceNo = invoiceNumberOf(latest);

      if (!latestInvoiceNo) {
        useLegacyReceipt = true;
        return;
      }

      const [printPayload, costDataRow, historyParcel] = await Promise.all([
        getInvoiceForPrint(latestInvoiceNo),
        fetchParcelCostDetails(parcelId).catch(() => ({})),
        fetchParcelBookingByParcelNo(parcelId).catch(() => null),
      ]);

      if (!printPayload) {
        toast.error("Could not load the latest invoice.");
        return;
      }

      const detailObj =
        historyParcel && typeof historyParcel === "object" ? historyParcel : {};

      const slipData = buildInvoiceSlipFromPrintPayload({
        printPayload,
        parcelRow: {
          ...parcel,
          parcelId,
          senderName: parcel.senderName || detailObj.senderName,
          senderEmail: parcel.senderEmail || detailObj.senderEmail,
          receiverName: parcel.receiverName || detailObj.receiverName,
          receiverEmail: parcel.receiverEmail || detailObj.receiverEmail,
        },
        costData: { ...costDataRow, ...detailObj },
        invoiceRow: {
          ...latest,
          paymentInvoiceNo: latestInvoiceNo,
          version: latest.version ?? latest.Version,
        },
        invoiceHistory: invoices,
        lookups,
      });

      if (!slipData) {
        toast.error("Could not prepare the latest invoice.");
        return;
      }

      localStorage.setItem("paymentSlipData", JSON.stringify(slipData));
      window.open("/paymentslip", "_blank");
    } catch (err) {
      console.error("Latest invoice download failed", err);
      toast.error(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to download latest invoice.",
      );
    } finally {
      setLoadingReport(false);
      if (useLegacyReceipt) {
        openLegacyReceipt(parcel);
      }
    }
  };

  const fetchParcelReportDetails = (parcel) => {
    downloadLatestInvoice(parcel);
  };

  const generateReceipt = () => {
    if (!parcelData) return null;

    const totalAmount = (costData?.subTotal || 0) + (costData?.vaT_TaxAmount || 0);

    return (
      <div ref={targetRef} className="p-4" style={{ 
        width: '794px', 
        fontFamily: 'Arial, sans-serif',
        fontSize: '14px',
        color: '#333333',
        backgroundColor: '#ffffff'
      }}>
        {/* Header */}
        <div className="text-center mb-4">
          <h1 className="text-2xl font-bold" style={{ color: '#222222' }}>Parcel Receipt</h1>
          <div className="flex justify-between text-sm mt-2" style={{ color: '#555555' }}>
            <p>Date: {format(new Date(), "dd/MM/yyyy HH:mm")}</p>
            <p>Parcel No: #{parcelData.parcelNo}</p>
          </div>
        </div>

        {/* Sender/Receiver Info */}
        <div className="grid grid-cols-2 gap-4 mb-4">
          <div className="border p-2" style={{ borderColor: '#dddddd' }}>
            <h3 className="font-bold border-b pb-1" style={{ borderColor: '#eeeeee' }}>Sender</h3>
            <p className="mt-1"><span className="font-semibold">Name:</span> {parcelData.senderName || "N/A"}</p>
            <p><span className="font-semibold">Email:</span> {parcelData.senderEmail || "N/A"}</p>
          </div>
          <div className="border p-2" style={{ borderColor: '#dddddd' }}>
            <h3 className="font-bold border-b pb-1" style={{ borderColor: '#eeeeee' }}>Receiver</h3>
            <p className="mt-1"><span className="font-semibold">Name:</span> {parcelData.receiverName || "N/A"}</p>
            <p><span className="font-semibold">Email:</span> {parcelData.receiverEmail || "N/A"}</p>
          </div>
        </div>

        {/* Parcel Details */}
        <div className="border p-2 mb-4" style={{ borderColor: '#dddddd' }}>
          <h3 className="font-bold border-b pb-1" style={{ borderColor: '#eeeeee' }}>Parcel Information</h3>
          <div className="grid grid-cols-3 gap-2 mt-1">
            <p><span className="font-semibold">Route:</span> {parcelData.routeName || "N/A"}</p>
            <p><span className="font-semibold">Cargo Type:</span> {parcelData.cargoTypeName || "N/A"}</p>
            <p><span className="font-semibold">Status:</span> {parcelData.currentParcelStatusName || "Pending"}</p>
            <p><span className="font-semibold">Dimension:</span> {parcelData.dimensionName || "N/A"}</p>
            <p><span className="font-semibold">Weight:</span> {parcelData.weightDescription || "N/A"}</p>
            <p><span className="font-semibold">Created:</span> {formatDate(parcelData.parcelCreationDate)}</p>
          </div>
        </div>

        {/* Cost Breakdown */}
        <div className="border p-2 mb-4" style={{ borderColor: '#dddddd' }}>
          <h3 className="font-bold border-b pb-1" style={{ borderColor: '#eeeeee' }}>Payment Details</h3>
          <table className="w-full mt-1">
            <tbody>
              {/* {costData?.weightCost !== undefined && (
                <tr>
                  <td className="font-semibold">Weight Cost:</td>
                  <td className="text-right">{parcelData.symbol} {costData.weightCost || 0}</td>
                </tr>
              )}
              {costData?.dimensionCost !== undefined && (
                <tr>
                  <td className="font-semibold">Dimension Cost:</td>
                  <td className="text-right">{parcelData.symbol} {costData.dimensionCost || 0}</td>
                </tr>
              )}
              {costData?.routeCost !== undefined && (
                <tr>
                  <td className="font-semibold">Route Cost:</td>
                  <td className="text-right">{parcelData.symbol} {costData.routeCost || 0}</td>
                </tr>
              )}
              {costData?.vaT_TaxAmount !== undefined && (
                <tr>
                  <td className="font-semibold" style={{marginTop:"2px"}}>VAT Tax:</td>
                  <td className="text-right">{parcelData.symbol} {costData.vaT_TaxAmount || 0}</td>
                </tr>
              )}
              
              <tr className="border-t" style={{ borderColor: '#eeeeee'}}>
                <td className="font-bold">Subtotal:</td>
                <td className="text-right font-bold">{parcelData.symbol} {costData?.subTotal || parcelData.subTotal || 0}</td>
              </tr> */}
              <tr className="border-t-2" style={{ borderColor: '#dddddd' ,marginTop:" 1px" }}>
                <td className="font-bold text-lg">Total Amount:</td>
                <td className="text-right font-bold text-lg">
                  {formatCurrency(totalAmount, parcelData.symbol || "GBP")}
                </td>
              </tr>
              <tr>
                <td className="font-bold">Payment Status:</td>
                <td className="text-right">
                  <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full `}>
                    {parcelData.statusName || "N/A"}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div className="text-center text-xs mt-6" style={{ color: '#777777' }}>
          <p>Thank you for using our service</p>
          <p className="mt-1">For any queries, please contact our customer support</p>
        </div>
      </div>
    );
  };

  return (
    <div
      className={
        embedded
          ? "bg-transparent"
          : "bg-white rounded-2xl border border-[#e8ddd4] shadow-sm p-4 sm:p-5"
      }
    >
      {/* Search Input */}
      <div className="mb-4 relative">
        <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-stone-400 text-sm">
          ⌕
        </span>
        <input
          type="text"
          placeholder="Search by parcel, sender, receiver, route…"
          className="w-full h-11 pl-9 pr-3 rounded-xl border-2 border-[#e8ddd4] bg-[#fcfaf8] text-sm font-medium outline-none transition focus:border-[#6D4C41] focus:bg-white"
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(1);
          }}
        />
      </div>

      {/* Accordion table */}
      <div className="overflow-x-auto rounded-xl border border-[#efe6df]">
        <table className="min-w-full divide-y divide-[#efe6df]">
          <thead className="bg-[#f7f1ec]">
            <tr>
              <th className="px-4 sm:px-6 py-3.5 text-left text-[11px] font-bold text-stone-600 uppercase tracking-wider">
                Parcel No
              </th>
              <th className="px-4 sm:px-6 py-3.5 text-left text-[11px] font-bold text-stone-600 uppercase tracking-wider">
                Date
              </th>
              <th className="px-4 sm:px-6 py-3.5 text-left text-[11px] font-bold text-stone-600 uppercase tracking-wider">
                Sender
              </th>
              <th className="px-4 sm:px-6 py-3.5 text-left text-[11px] font-bold text-stone-600 uppercase tracking-wider">
                Receiver
              </th>
              <th className="px-4 sm:px-6 py-3.5 text-left text-[11px] font-bold text-stone-600 uppercase tracking-wider">
                Route
              </th>
              <th className="px-4 sm:px-6 py-3.5 text-left text-[11px] font-bold text-stone-600 uppercase tracking-wider">
                Amount
              </th>
              <th className="px-4 sm:px-6 py-3.5 text-left text-[11px] font-bold text-stone-600 uppercase tracking-wider">
                Status
              </th>
              <th className="px-4 sm:px-6 py-3.5 text-left text-[11px] font-bold text-stone-600 uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-[#efe6df]">
            {paginatedData.length > 0 ? (
              paginatedData.map((item, index) => {
                const isExpanded = selectedParcel === item.parcelNo;
                const detailsForRow =
                  isExpanded && viewParcel?.parcelNo === item.parcelNo
                    ? viewDetails
                    : null;
                const loadingThis =
                  isExpanded &&
                  loadingView &&
                  viewParcel?.parcelNo === item.parcelNo;

                return (
                  <React.Fragment key={item.parcelNo ?? index}>
                    <tr
                      onClick={() => handleRowClick(item)}
                      className={`${
                        index % 2 === 0 ? "bg-white" : "bg-gray-50"
                      } ${
                        isExpanded ? "bg-blue-50/70" : ""
                      } cursor-pointer hover:bg-gray-100`}
                      aria-expanded={isExpanded}
                    >
                      <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                        <span className="inline-flex items-center gap-2">
                          <FiChevronDown
                            className={`text-stone-500 transition-transform ${
                              isExpanded ? "rotate-180" : ""
                            }`}
                          />
                          {item.parcelNo || "N/A"}
                        </span>
                      </td>
                      <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                        {formatDate(item.parcelCreationDate)}
                      </td>
                      <td className="px-4 sm:px-6 py-4 text-sm text-gray-700 max-w-[10rem] truncate">
                        {item.senderName || "N/A"}
                      </td>
                      <td className="px-4 sm:px-6 py-4 text-sm text-gray-700 max-w-[10rem] truncate">
                        {item.receiverName || "N/A"}
                      </td>
                      <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                        {item.routeName || "N/A"}
                      </td>
                      <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                        {formatCurrency(
                          item.subTotal ||
                            item.orderPayableAmount ||
                            item.totalAmount ||
                            0,
                          item.symbol || "GBP",
                        )}
                      </td>
                      <td className="px-4 sm:px-6 py-4 whitespace-nowrap">
                        <span
                          className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full border ${paymentStatusBadgeClass(
                            rowPaymentStatus(item, detailsForRow),
                          )}`}
                        >
                          {rowPaymentStatus(item, detailsForRow) || "N/A"}
                        </span>
                      </td>
                      <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2">
                          <button
                            type="button"
                            onClick={(e) => openViewAccordion(e, item)}
                            className="text-stone-700 hover:text-stone-900 flex items-center gap-1 font-medium"
                          >
                            <FiEye className="inline" />
                            {isExpanded ? "Hide" : "View"}
                          </button>
                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              fetchParcelReportDetails(item);
                            }}
                            disabled={
                              loadingReport &&
                              parcelData?.parcelNo === item.parcelNo
                            }
                            className="text-blue-600 hover:text-blue-800 flex items-center gap-1"
                          >
                            <FiFileText className="inline" />
                            {loadingReport &&
                            parcelData?.parcelNo === item.parcelNo
                              ? "Loading..."
                              : "Invoice"}
                          </button>
                          {showRefund ? (
                            <button
                              type="button"
                              onClick={(e) => openRefundModal(e, item)}
                              className="text-green-700 hover:text-green-900 flex items-center gap-1 font-medium"
                            >
                              <Icon icon="logos:whatsapp-icon" width={16} />
                              Refund
                            </button>
                          ) : null}
                        </div>
                      </td>
                    </tr>

                    {isExpanded && (
                      <tr className="bg-stone-50">
                        <td
                          colSpan={8}
                          className="px-3 sm:px-6 py-4 border-t border-blue-100"
                        >
                          <div className="space-y-4 min-w-0 max-w-full overflow-hidden">
                            <div>
                              <p className="text-[11px] font-bold uppercase tracking-wide text-stone-500 mb-2">
                                Tracking details
                              </p>
                              <VerticalProgressBar
                                embedded
                                statusData={parcelStatusData}
                                loading={statusLoading}
                                currentStatus={pickDetail(
                                  detailsForRow?.currentParcelStatusName,
                                  item.currentParcelStatusName,
                                )}
                                routeName={pickDetail(
                                  detailsForRow?.routeName,
                                  item.routeName,
                                )}
                                parcelNo={item.parcelNo}
                              />
                            </div>

                            <div>
                              <p className="text-[11px] font-bold uppercase tracking-wide text-stone-500 mb-2">
                                Parcel details
                              </p>
                              {loadingThis ? (
                                <div className="py-8 text-center text-stone-500 font-medium rounded-lg border border-stone-200 bg-white">
                                  Loading parcel details…
                                </div>
                              ) : (
                                <div className="space-y-3 min-w-0">
                                  <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
                                    <div className="rounded-lg border border-stone-200 bg-white px-3 py-2 min-w-0 overflow-hidden">
                                      <p className="text-[10px] font-bold uppercase text-stone-500">
                                        Amount
                                      </p>
                                      <p className="text-sm font-semibold text-stone-900 break-words">
                                        {viewAmount(detailsForRow || item)}
                                      </p>
                                    </div>
                                    <div className="rounded-lg border border-stone-200 bg-white px-3 py-2 min-w-0 overflow-hidden">
                                      <p className="text-[10px] font-bold uppercase text-stone-500">
                                        Payment
                                      </p>
                                      <p className="text-sm font-semibold text-stone-900 break-words">
                                        {pickDetail(
                                          detailsForRow?.paymentHistory
                                            ?.paymentStatus,
                                          detailsForRow?.paymentStatusName,
                                          item.paymentStatus,
                                          item.statusName,
                                        ) || "—"}
                                      </p>
                                    </div>
                                    <div className="rounded-lg border border-stone-200 bg-white px-3 py-2 min-w-0 overflow-hidden">
                                      <p className="text-[10px] font-bold uppercase text-stone-500">
                                        Parcel status
                                      </p>
                                      <p className="text-sm font-semibold text-stone-900 break-words">
                                        {pickDetail(
                                          detailsForRow?.currentParcelStatusName,
                                          item.currentParcelStatusName,
                                        ) || "—"}
                                      </p>
                                    </div>
                                    <div className="rounded-lg border border-stone-200 bg-white px-3 py-2 min-w-0 overflow-hidden">
                                      <p className="text-[10px] font-bold uppercase text-stone-500">
                                        Latest invoice
                                      </p>
                                      <p className="text-sm font-semibold text-stone-900 break-all">
                                        {detailsForRow?.latestInvoiceNo || "—"}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 min-w-0">
                                    <div className="rounded-xl border border-stone-200 bg-white p-3 min-w-0 overflow-hidden">
                                      <p className="text-[11px] font-bold uppercase tracking-wide text-orange-600 mb-2">
                                        Sender
                                      </p>
                                      <DetailRow
                                        label="Name"
                                        value={pickDetail(
                                          detailsForRow?.senderName,
                                          item.senderName,
                                        )}
                                      />
                                      <DetailRow
                                        label="Email"
                                        value={pickDetail(
                                          detailsForRow?.senderEmail,
                                          item.senderEmail,
                                        )}
                                      />
                                      <DetailRow
                                        label="Phone"
                                        value={pickDetail(
                                          detailsForRow?.senderPhone,
                                          item.senderPhone,
                                        )}
                                      />
                                      <DetailRow
                                        label="Address"
                                        value={pickDetail(
                                          detailsForRow?.senderAddress,
                                        )}
                                      />
                                    </div>
                                    <div className="rounded-xl border border-stone-200 bg-white p-3 min-w-0 overflow-hidden">
                                      <p className="text-[11px] font-bold uppercase tracking-wide text-orange-600 mb-2">
                                        Receiver
                                      </p>
                                      <DetailRow
                                        label="Name"
                                        value={pickDetail(
                                          detailsForRow?.receiverName,
                                          item.receiverName,
                                        )}
                                      />
                                      <DetailRow
                                        label="Email"
                                        value={pickDetail(
                                          detailsForRow?.receiverEmail,
                                          item.receiverEmail,
                                        )}
                                      />
                                      <DetailRow
                                        label="Phone"
                                        value={pickDetail(
                                          detailsForRow?.receiverPhone,
                                          item.receiverPhone,
                                        )}
                                      />
                                      <DetailRow
                                        label="Address"
                                        value={pickDetail(
                                          detailsForRow?.receiverAddress,
                                        )}
                                      />
                                    </div>
                                  </div>

                                  <div className="rounded-xl border border-stone-200 bg-white p-3 min-w-0 overflow-hidden space-y-3">
                                    <p className="text-[11px] font-bold uppercase tracking-wide text-orange-600">
                                      Shipment
                                    </p>
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 min-w-0">
                                      <DetailRow
                                        label="Route"
                                        value={pickDetail(
                                          detailsForRow?.routeName,
                                          item.routeName,
                                        )}
                                      />
                                      <DetailRow
                                        label="Cargo"
                                        value={pickDetail(
                                          detailsForRow?.cargoTypeName,
                                          item.cargoTypeName,
                                        )}
                                      />
                                      <DetailRow
                                        label="Record serial"
                                        value={pickDetail(
                                          detailsForRow?.recordSerialNo,
                                          detailsForRow?.barcode,
                                          item.recordSerialNo,
                                        )}
                                      />
                                      <DetailRow
                                        label="Invoices"
                                        value={
                                          detailsForRow?.invoiceCount != null
                                            ? String(detailsForRow.invoiceCount)
                                            : "—"
                                        }
                                      />
                                      <DetailRow
                                        label="Item"
                                        value={pickDetail(
                                          detailsForRow?.uniqItemDescription,
                                          item.uniqItemDescription,
                                        )}
                                      />
                                      <DetailRow
                                        label="Service"
                                        value={pickDetail(
                                          detailsForRow?.shippingServiceName,
                                          item.shippingServiceName,
                                        )}
                                      />
                                    </div>

                                    {detailsForRow?.measurements &&
                                    (detailsForRow.measurements.customerInput ||
                                      detailsForRow.measurements
                                        .hubMeasurement) ? (
                                      <MeasurementCompare
                                        customerInput={
                                          detailsForRow.measurements
                                            .customerInput
                                        }
                                        hubMeasurement={
                                          detailsForRow.measurements
                                            .hubMeasurement
                                        }
                                        weightBandName={
                                          detailsForRow.measurements
                                            .weightBandName
                                        }
                                        dimensionName={
                                          detailsForRow.measurements
                                            .dimensionName
                                        }
                                      />
                                    ) : (
                                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 min-w-0">
                                        <DetailRow
                                          label="Weight"
                                          value={pickDetail(
                                            detailsForRow?.weightDescription,
                                            item.weightDescription,
                                          )}
                                        />
                                        <DetailRow
                                          label="Dimension"
                                          value={pickDetail(
                                            detailsForRow?.dimensionName,
                                            item.dimensionName,
                                          )}
                                        />
                                      </div>
                                    )}
                                  </div>

                                  {showCarrierPartner &&
                                  Array.isArray(detailsForRow?.carrierPartners) &&
                                  detailsForRow.carrierPartners.length > 0 ? (
                                    <CarrierPartnerPanel
                                      partners={detailsForRow.carrierPartners}
                                    />
                                  ) : null}

                                  {showAmendmentDetails &&
                                  Array.isArray(detailsForRow?.amendments) &&
                                  detailsForRow.amendments.length > 0 ? (
                                    <AmendmentDetailsPanel
                                      amendments={detailsForRow.amendments}
                                      symbol={
                                        detailsForRow.symbol ||
                                        item.symbol ||
                                        "GBP"
                                      }
                                    />
                                  ) : null}

                                  {paymentHistoryItems(detailsForRow).length >
                                  0 ? (
                                    <PaymentHistoryTimeline
                                      history={detailsForRow.paymentHistory}
                                      symbol={
                                        detailsForRow.symbol ||
                                        item.symbol ||
                                        "GBP"
                                      }
                                    />
                                  ) : hasPaymentDetails(detailsForRow) ? (
                                    <div className="rounded-xl border border-emerald-200 bg-emerald-50/40 p-3 min-w-0 overflow-hidden">
                                      <p className="text-[11px] font-bold uppercase tracking-wide text-emerald-700 mb-2">
                                        Payment details
                                      </p>
                                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 min-w-0">
                                        {detailsForRow.paymentMethodName ? (
                                          <DetailRow
                                            label="Method"
                                            value={
                                              detailsForRow.paymentMethodName
                                            }
                                          />
                                        ) : null}
                                        {detailsForRow.paymentStatusName ? (
                                          <DetailRow
                                            label="Status"
                                            value={
                                              detailsForRow.paymentStatusName
                                            }
                                          />
                                        ) : null}
                                        {detailsForRow.paymentInvoiceNo ? (
                                          <DetailRow
                                            label="Invoice"
                                            value={
                                              detailsForRow.paymentInvoiceNo
                                            }
                                          />
                                        ) : null}
                                        {detailsForRow.paidAmount ? (
                                          <DetailRow
                                            label="Amount"
                                            value={formatCurrency(
                                              detailsForRow.paidAmount,
                                              detailsForRow.symbol || "GBP",
                                            )}
                                          />
                                        ) : null}
                                        {detailsForRow.paymentDate ? (
                                          <DetailRow
                                            label="Paid on"
                                            value={formatPaymentDate(
                                              detailsForRow.paymentDate,
                                            )}
                                          />
                                        ) : null}
                                        {detailsForRow.cardLast4 ? (
                                          <DetailRow
                                            label="Card"
                                            value={`${
                                              detailsForRow.cardBrand
                                                ? `${detailsForRow.cardBrand} `
                                                : ""
                                            }•••• ${detailsForRow.cardLast4}`}
                                          />
                                        ) : null}
                                        {detailsForRow.stripePaymentMethod ? (
                                          <DetailRow
                                            label="Stripe method"
                                            value={
                                              detailsForRow.stripePaymentMethod
                                            }
                                          />
                                        ) : null}
                                        {detailsForRow.stripePaymentIntentId ? (
                                          <DetailRow
                                            label="Intent"
                                            value={
                                              detailsForRow.stripePaymentIntentId
                                            }
                                          />
                                        ) : null}
                                        {detailsForRow.stripeChargeId ? (
                                          <DetailRow
                                            label="Charge"
                                            value={
                                              detailsForRow.stripeChargeId
                                            }
                                          />
                                        ) : null}
                                        {detailsForRow.paymentDescription ? (
                                          <DetailRow
                                            label="Note"
                                            value={
                                              detailsForRow.paymentDescription
                                            }
                                          />
                                        ) : null}
                                      </div>
                                    </div>
                                  ) : null}

                                  <div className="flex flex-wrap justify-end gap-2 pt-1">
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        downloadLatestInvoice(item);
                                      }}
                                      className="px-4 py-2 rounded-lg bg-blue-600 text-white font-semibold hover:bg-blue-700 inline-flex items-center gap-1.5 text-sm"
                                    >
                                      <FiFileText />
                                      Open invoice
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })
            ) : (
              <tr>
                <td
                  colSpan="8"
                  className="px-6 py-4 text-center text-sm text-gray-700"
                >
                  No booking history found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mt-4">
          <p className="text-xs font-medium text-stone-500">
            Page {currentPage} of {totalPages}
            <span className="text-stone-400">
              {" "}
              · {filteredData.length} parcels
            </span>
          </p>
          <div className="flex flex-wrap items-center gap-1.5">
            <button
              type="button"
              onClick={() => handlePageChange(Math.max(1, currentPage - 1))}
              disabled={currentPage === 1}
              className="px-3 py-1.5 border border-stone-200 rounded-lg text-sm font-medium text-stone-700 bg-white hover:bg-stone-50 disabled:opacity-50"
            >
              Previous
            </button>
            <div className="hidden sm:flex flex-wrap items-center gap-1">
              {paginationItems(currentPage, totalPages).map((item) =>
                typeof item === "string" ? (
                  <span
                    key={item}
                    className="px-1.5 text-stone-400 text-sm select-none"
                  >
                    …
                  </span>
                ) : (
                  <button
                    key={item}
                    type="button"
                    onClick={() => handlePageChange(item)}
                    className={`min-w-[36px] h-9 px-2 border rounded-lg text-sm font-medium ${
                      currentPage === item
                        ? "bg-stone-900 text-white border-stone-900"
                        : "bg-white text-stone-700 border-stone-200 hover:bg-stone-50"
                    }`}
                  >
                    {item}
                  </button>
                ),
              )}
            </div>
            <select
              value={currentPage}
              onChange={(e) => handlePageChange(Number(e.target.value))}
              className="sm:hidden h-9 px-2 border border-stone-200 rounded-lg text-sm font-medium bg-white"
              aria-label="Jump to page"
            >
              {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                (page) => (
                  <option key={page} value={page}>
                    {page}
                  </option>
                ),
              )}
            </select>
            <button
              type="button"
              onClick={() =>
                handlePageChange(Math.min(totalPages, currentPage + 1))
              }
              disabled={currentPage === totalPages}
              className="px-3 py-1.5 border border-stone-200 rounded-lg text-sm font-medium text-stone-700 bg-white hover:bg-stone-50 disabled:opacity-50"
            >
              Next
            </button>
          </div>
        </div>
      )}

      {/* Receipt Modal (Optional) */}
      {showRefundModal && refundParcel && (
        <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex justify-center items-center px-4">
          <div
            className="bg-white max-w-md w-full rounded-lg shadow-lg p-6 relative"
            role="dialog"
            aria-modal="true"
            aria-labelledby="refund-modal-title"
          >
            <button
              type="button"
              onClick={closeRefundModal}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-xl font-bold"
              aria-label="Close refund dialog"
            >
              &times;
            </button>
            <div className="flex items-center gap-3 mb-4">
              <Icon icon="logos:whatsapp-icon" width={32} />
              <h2
                id="refund-modal-title"
                className="text-xl font-bold text-gray-900"
              >
                Request a refund
              </h2>
            </div>
            <p className="text-gray-600 mb-2">
              Refunds are handled by our support team on WhatsApp.
            </p>
            <p className="text-gray-600 mb-4">
              Please contact us on WhatsApp with parcel{" "}
              <span className="font-semibold text-gray-900">
                #{refundParcel.parcelNo}
              </span>{" "}
              and we will assist you as soon as possible.
            </p>
            <div className="flex flex-col gap-2 mb-4">
              {REFUND_WHATSAPP_CONTACTS.map((contact) => (
                <a
                  key={contact.waId}
                  href={buildRefundWhatsAppUrl(contact.waId, refundParcel)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg bg-green-600 text-white font-semibold hover:bg-green-700"
                >
                  <Icon icon="logos:whatsapp-icon" width={18} />
                  Chat on {contact.label}
                </a>
              ))}
            </div>
            <div className="flex justify-end">
              <button
                type="button"
                onClick={closeRefundModal}
                className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 font-medium hover:bg-gray-50"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {showReportModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex justify-center items-center px-4">
          <div className="bg-white max-w-4xl w-full max-h-[90vh] overflow-y-auto rounded-lg shadow-lg p-4 relative">
            <button
              onClick={() => setShowReportModal(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-xl font-bold"
            >
              &times;
            </button>
            {generateReceipt()}
            <div className="flex justify-end mt-4">
              <button
                onClick={toPDF}
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 flex items-center gap-2"
              >
                <FiDownload />
                Download PDF
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingHistoryTable;
